import { render } from "./Requisites.vue?vue&type=template&id=c541ce2a&scoped=true"
import script from "./Requisites.vue?vue&type=script&lang=js"
export * from "./Requisites.vue?vue&type=script&lang=js"

import "./Requisites.vue?vue&type=style&index=0&id=c541ce2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c541ce2a"]])

export default __exports__